import { computed } from '@angular/core';
import type { ReplaySiteBuilding } from '@wheere-front/domain-trackers';
import type { Map as MaplibreMap } from 'maplibre-gl';
import type { SiteModelClient } from '../data/site-model.client';
import { SiteBuildingState } from './site-building.state';

/**
 * Bâtiment 3D de la carte de rejeu des positions (ADR-017) : contours par défaut, comme la fiche
 * tracker ; pas de mannequin, les positions restent des points au sol dessinés par-dessus.
 */
export class ReplaySiteBuildingState extends SiteBuildingState implements ReplaySiteBuilding {
  readonly available = computed(() => this.model() !== null);

  constructor(private readonly client: Pick<SiteModelClient, 'get' | 'content'>) {
    super(false);
  }

  async load(map: MaplibreMap, siteId: string, overlays: readonly string[]): Promise<void> {
    try {
      const model = await this.client.get(siteId);
      if (!model) {
        return;
      }
      const glb = await this.client.content(siteId);
      await this.attach(map, model, glb, null, overlays);
    } catch (e) {
      console.error('[position-replay] modèle 3D du site', siteId, e);
      this.error.set(String(e));
    }
  }
}
